import { OmitStrict } from "@amx/ux-twoui-utils";
import React from "react";
import { InteractiveElementProps } from "../../../../../shared/props";
import { ActionButton, ActionButtonProps } from "../../../../Buttons/ActionButton/ActionButton";
import { MenuIconButtonProps } from "../../../../Buttons/MenuIconButton/MenuIconButton";
import { FlexibleMenu, FlexibleMenuProps } from "../../../../FlexibleMenu/FlexibleMenu";
import { StopPropagation } from "../../../../StopPropagation/StopPropagation";
import { enterKeyStopPropagation } from "../props";

export type DrawerHeaderActionActionButtonProps = ActionButtonProps;

export type DrawerHeaderActionMenuIconButtonProps = OmitStrict<MenuIconButtonProps, "iconColor" | "iconName">;

export interface DrawerHeaderActionProps extends InteractiveElementProps {
    /**
     * Alignment of the action inside the column. Defaults to start.
     */
    readonly actionAlignment?: "flex-start" | "center" | "flex-end";
    /**
     * Action button to display in the column.
     */
    readonly actionButton?: DrawerHeaderActionActionButtonProps;
    /**
     * Menu icon button to display in the column.
     */
    readonly menuIconButton?: DrawerHeaderActionMenuIconButtonProps;
}

export const DrawerHeaderAction: React.FC<DrawerHeaderActionProps> = ({
    actionAlignment,
    actionButton,
    menuIconButton,
    ...otherProps
}) => {

    const flexibleMenuProps: FlexibleMenuProps = {
        menuProps: menuIconButton,
        height: "40px",
        alignment: actionAlignment,
        ...otherProps
    };
    return (
        <StopPropagation keycodes={[enterKeyStopPropagation]}>
            <FlexibleMenu {...flexibleMenuProps} >
                {actionButton && <ActionButton {...actionButton} />}
            </FlexibleMenu>
        </StopPropagation>
    );
};
